import React, { useEffect, useState } from 'react';


import { MdDeleteOutline } from "react-icons/md";

import './courseHandler.css';


const CourseHandler = () => {
  const [loaded, setLoaded] = useState(false);
  const [courseData, setCourseData] = useState();

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/course');
        const responseData = await response.json();
        setCourseData(responseData.course);
        setLoaded(true);
      } catch (err) {
          console.log(err);
      }          
    } 
    fetchCourse();
  }, []);


  const deleteCourse = async (courseId) => {
    const confirm = window.confirm('Are sure you want to delete this course!')

    if(!confirm){
        return;
    }

    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/course/${courseId}`, {
        method: 'DELETE'
      })
    } catch (err) {
      console.log(err.message)
    }

    setCourseData(prevCourse => prevCourse.filter(c => c.id !== courseId))
  }

  return (
    <main className='courseHandler-lists-container'>
      <table className='courseHandler-table-controller'>   
        <thead>
          <tr className='course-table-tr'>
            <th>Title</th>
            <th>Day</th>
            <th>Time</th>
            <th>Date</th>
            <th>Location</th>
            <th id='course-table-edit'>Edit/Delete</th>
          </tr>    
        </thead>
        <tbody className='courseHandler-tbody'>
          {loaded && courseData.map((c,index) => (
            <tr key={index} className='courseHandler-lists-tr' >                 
              <td>{c.title}</td>
              <td>{c.day}</td>
              <td>{c.time}</td>
              <td>{c.date}</td>
              <td>{c.location}</td>                
              <td id='course-table-delete'>
      
                <MdDeleteOutline onClick={() => deleteCourse(c.id)} style={{fontSize: '25px', color: 'red', marginRight: '15px'}}/>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>     
  )
}
export default CourseHandler;
